import prodConfig from './firebase.config.prod';
import stageConfig from './firebase.config.stage';
import prodUkConfig from './firebase.config.prod-uk'

let firebaseConfig = process.env.REACT_APP_ENVIRONMENT === 'prod' ? prodConfig :
    process.env.REACT_APP_ENVIRONMENT === 'prod-uk' ? prodUkConfig :
    stageConfig;

firebaseConfig.authDomain = process.env.REACT_APP_ENVIRONMENT === "prod" ?
    window.location.hostname === 'localhost' ?
        firebaseConfig.authDomain :
        window.location.hostname :
    firebaseConfig.authDomain;

export default firebaseConfig;
